webpackJsonp([114276838955818,60335399758886],{

/***/ 216:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(418);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(216);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 759:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Address = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(759);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Address = exports.Address = function (_React$Component) {
		_inherits(Address, _React$Component);
	
		function Address(args) {
			_classCallCheck(this, Address);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
			_this.state = {
				Error: {},
				values: {}
			};
			return _this;
		}
	
		Address.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				{ className: "section__content" },
				_react2.default.createElement(
					"div",
					{ className: "add__wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "add__section" },
						_react2.default.createElement(
							"div",
							{ className: "add_content" },
							_react2.default.createElement(
								"div",
								{ className: "add_head" },
								"REGISTERED ADDRESS :"
							),
							_react2.default.createElement(
								"div",
								{ className: "add_subtext" },
								"Winpe Development Forum ",
								_react2.default.createElement("br", null),
								"Upper Ground Floor, 376, Block B, Patparganj Road, Nirman Vihar",
								_react2.default.createElement("br", null),
								"East Delhi, Delhi - 110092"
							)
						)
					)
				)
			);
		};
	
		return Address;
	}(_react2.default.Component);
	
	exports.default = Address;

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var Routes = exports.Routes = [{
	  id: 1,
	  identifier: "about",
	  title: "About",
	  dropdown: [{
	    id: 1,
	    title: "Vision",
	    identifier: "vision"
	  }, {
	    id: 3,
	    title: "People",
	    identifier: "people"
	  }, {
	    id: 4,
	    title: "press",
	    identifier: "press",
	    isDifferentPage: true
	  }, {
	    id: 4,
	    title: "Charter",
	    identifier: "winpecharter",
	    isDifferentPage: true
	  }]
	}, {
	  id: 2,
	  identifier: "initiatives",
	  title: "Initiatives",
	  dropdown: [{
	    id: 1,
	    title: "Events",
	    identifier: "events",
	    isDifferentPage: true
	  }, {
	    id: 2,
	    title: "Testimonials",
	    identifier: "testimonials",
	    isDifferentPage: true
	  }]
	}, {
	  id: 3,
	  identifier: "insights",
	  title: "insights",
	  isDifferentPage: true
	  // dropdown: [
	  // 	{
	  // 		id: 1,
	  // 		title: "Kirthiga Reddy of SoftBank Investment Advisers",
	  // 		identifier: "superpowerofand",
	  // 		isDifferentPage: true,
	  // 	},
	  // 	{
	  // 		id: 1,
	  // 		title: "Inclusive Leadership: The Next Normal",
	  // 		identifier: "inclusiveleadership",
	  // 		isDifferentPage: true,
	  // 	},
	  // 	{
	  // 		id: 1,
	  // 		title: "Lizzie chapman of ZestMoney",
	  // 		identifier: "navigatingfundraising",
	  // 		isDifferentPage: true,
	  // 	},
	  // 	{
	  // 		id: 1,
	  // 		title: "Diversity at Risk: The Next Normal",
	  // 		identifier: "diversityatrisk",
	  // 		isDifferentPage: true,
	  // 	},
	  // 	{
	  // 		id: 1,
	  // 		title: "Manisha Girotra of Moelis & Company",
	  // 		identifier: "holdingmyown",
	  // 		isDifferentPage: true,
	  // 	},
	  // 	{
	  // 		id: 1,
	  // 		title: "Reimagining the Workplace: The Next Normal",
	  // 		identifier: "reimaginingtheworkplace",
	  // 		isDifferentPage: true,
	  // 	},
	  // 	{
	  // 		id: 1,
	  // 		title: "Padmaja Ruparel of Indian Angel Network",
	  // 		identifier: "padmajaruparelofindianangelnetwork",
	  // 		isDifferentPage: true,
	  // 	},
	  // 	{
	  // 		id: 1,
	  // 		title: "Alagappan Murugappan of CDC Group",
	  // 		identifier: "changingtimesadfiperspective",
	  // 		isDifferentPage: true,
	  // 	},
	  // 	{
	  // 		id: 2,
	  // 		title: "Shweta Jalan of Advent International",
	  // 		identifier: "shwetajalanofadventinternational",
	  // 		isDifferentPage: true,
	  // 	},
	  // 	{
	  // 		id: 3,
	  // 		title: "Bala C Deshpande of MegaDelta Capital",
	  // 		identifier: "thestockdaleparadox",
	  // 		isDifferentPage: true,
	  // 	},
	  // 	{
	  // 		id: 4,
	  // 		title: "Nupur Garg of WinPE Forum",
	  // 		identifier: "myLPmusings",
	  // 		isDifferentPage: true,
	  // 	},
	  // 	{
	  // 		id: 4,
	  // 		title: "Celebrating Women in Investing",
	  // 		identifier: "celebratingwomenininvesting",
	  // 		isDifferentPage: true,
	  // 	},
	  // ]
	}, {
	  id: 4,
	  identifier: "partners",
	  title: "Partners"
	  // dropdown: [
	  //   // {
	  //   // 	id: 2,
	  //   // 	title: "Partner Manifesto",
	  //   // 	identifier: "winpemanifesto",
	  //   // },
	  // ],
	}, {
	  id: 5,
	  identifier: "knowledgeresources",
	  title: "knowledge center",
	  isDifferentPage: true
	}, {
	  id: 6,
	  identifier: "connect",
	  title: "Connect",
	  isDifferentPage: true
	  // dropdown: [
	  // 	{
	  // 		id: 1,
	  // 		title: "Careers",
	  // 		identifier: "careers",
	  // 		isDifferentPage: true
	  // 	},
	  // ]
	}];
	
	exports.default = Routes;

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Sidebar = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(768);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Routes = __webpack_require__(251);
	
	var _Routes2 = _interopRequireDefault(_Routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Subscribe from "../../components/Subscribe"
	
	var Sidebar = exports.Sidebar = function (_React$Component) {
		_inherits(Sidebar, _React$Component);
	
		function Sidebar(args) {
			_classCallCheck(this, Sidebar);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
			_this.handleToggle = function (activeIdentifier) {
				_this.setState({ activeIdentifier: activeIdentifier });
			};
	
			_this.handleActiveNav = function (identifier) {
				var onHide = _this.props.onHide;
				// this.setState({
				// })
	
				_this.setState({
					// isNavChange: false,
					routeUrl: "/"
				});
				onHide();
				// setTimeout(() => {
				// 	this.setState({
				// 		isNavChange: true,
				// 	})
				// }, 0)
			};
	
			_this.state = {
				activeIdentifier: null,
				routeUrl: "/"
			};
			return _this;
		}
	
		Sidebar.prototype.componentDidMount = function componentDidMount() {
			window.addEventListener("scroll", this.handleScroll, true);
			this.setState({
				// isNavChange: false,
				routeUrl: window.location.pathname
			});
		};
	
		Sidebar.prototype.render = function render() {
			var _this2 = this;
	
			var _props = this.props,
			    show = _props.show,
			    onHide = _props.onHide,
			    activePathname = _props.activePathname;
			var _state = this.state,
			    activeIdentifier = _state.activeIdentifier,
			    routeUrl = _state.routeUrl;
	
			var activeUrl = routeUrl === "/" || routeUrl === "/home";
			return _react2.default.createElement(
				_Modal2.default,
				{ direction: "right", className: "sidebar", show: show, onHide: onHide },
				_react2.default.createElement(
					_Modal2.default.Header,
					null,
					_react2.default.createElement(
						"span",
						{ className: "cross" },
						_react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
					)
				),
				_react2.default.createElement(
					_Modal2.default.Body,
					null,
					_react2.default.createElement(
						"div",
						{ className: "tabs" },
						_react2.default.createElement(
							"ul",
							{ id: "mobile__tabs", className: "" },
							_Routes2.default.map(function (item) {
								return _react2.default.createElement(
									"li",
									{ key: item.id, className: "menu__text" + ("" + activePathname === "#" + item.identifier ? "-active" : "") },
									item.isDifferentPage ? _react2.default.createElement(
										"a",
										{ onClick: onHide, href: "/" + item.identifier, className: "" },
										item.title
									) : !activeUrl ? _react2.default.createElement(
										_gatsbyLink2.default,
										{ onClick: function onClick() {
												return _this2.handleActiveNav(item.title);
											}, to: "/home#" + item.identifier },
										item.title
									) : _react2.default.createElement(
										"a",
										{ onClick: function onClick() {
												return _this2.handleActiveNav(item.title);
											}, href: "/home#" + item.identifier },
										item.title
									),
									item.dropdown ? _react2.default.createElement(
										"span",
										null,
										_react2.default.createElement("i", { onClick: function onClick() {
												return _this2.handleToggle(activeIdentifier ? null : item.identifier);
											}, className: "fa fa-angle-up " + (activeIdentifier !== item.identifier ? "toggle__rotate" : "") })
									) : null,
									activeIdentifier === item.identifier ? _react2.default.createElement(
										"div",
										{ className: "dropdown-content" },
										item.dropdown && item.dropdown.map(function (item) {
											return item.isDifferentPage ? _react2.default.createElement(
												"div",
												null,
												_react2.default.createElement(
													"a",
													{ className: "", href: "/" + item.identifier },
													"- ",
													item.title
												)
											) : !activeUrl ? _react2.default.createElement(
												_gatsbyLink2.default,
												{ to: "/home#" + item.identifier, key: item.id, className: "" },
												_react2.default.createElement(
													"span",
													null,
													"- ",
													item.title
												)
											) : _react2.default.createElement(
												"a",
												{ href: "#" + item.identifier, key: item.id, className: "" },
												_react2.default.createElement(
													"span",
													null,
													"- ",
													item.title
												)
											);
										})
									) : null
								);
							})
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "social_icons" },
						_react2.default.createElement(
							"span",
							{ className: "icon" },
							_react2.default.createElement(
								"a",
								{ rel: "noopener noreferrer", href: "https://www.facebook.com/winpeforum/", target: "_blank", className: "" },
								_react2.default.createElement("i", { className: "fa fa-facebook" })
							)
						),
						_react2.default.createElement(
							"span",
							{ className: "icon" },
							_react2.default.createElement(
								"a",
								{ rel: "noopener noreferrer", href: "https://twitter.com/winpeforum", target: "_blank", className: "" },
								_react2.default.createElement("i", { className: "fa fa-twitter" })
							)
						),
						_react2.default.createElement(
							"span",
							{ className: "icon" },
							_react2.default.createElement(
								"a",
								{ rel: "noopener noreferrer", href: "https://www.linkedin.com/company/winpeforum", target: "_blank", className: "" },
								_react2.default.createElement("i", { className: "fa fa-linkedin" })
							)
						),
						_react2.default.createElement(
							"span",
							{ className: "icon" },
							_react2.default.createElement(
								"a",
								{ rel: "noopener noreferrer", href: "https://www.instagram.com/WinPEforum/", target: "_blank", className: "" },
								_react2.default.createElement("i", { className: "fa fa-instagram" })
							)
						),
						_react2.default.createElement(
							"span",
							{ className: "icon" },
							_react2.default.createElement(
								"a",
								{ rel: "noopener noreferrer", href: "https://www.youtube.com/watch?v=q-bE10X9KcA&t=2s", target: "_blank", className: "" },
								_react2.default.createElement("i", { className: "fa fa-youtube" })
							)
						),
						_react2.default.createElement(
							"span",
							{ className: "icon" },
							_react2.default.createElement(
								"a",
								{ rel: "noopener noreferrer", href: "https://winpeinsights.medium.com/", target: "_blank", className: "" },
								_react2.default.createElement("i", { className: "fa fa-medium", "aria-hidden": "true" })
							)
						),
						_react2.default.createElement(
							"span",
							{ className: "icon" },
							_react2.default.createElement(
								"a",
								{ rel: "noopener noreferrer", href: "https://www.winpeforum.com/whatsappgroups/", target: "_blank", className: "" },
								_react2.default.createElement("i", { className: "fa fa-whatsapp" })
							)
						)
					)
				)
			);
		};
	
		return Sidebar;
	}(_react2.default.Component);
	
	Sidebar.propTypes = {
		show: _propTypes2.default.bool,
		onHide: _propTypes2.default.func,
		activePathname: _propTypes2.default.string
	};
	
	exports.default = Sidebar;

/***/ }),

/***/ 768:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Sidebar = __webpack_require__(398);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Sidebar2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NavBar = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(769);
	
	var _Routes = __webpack_require__(251);
	
	var _Routes2 = _interopRequireDefault(_Routes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import AnchorLink from "react-anchor-link-smooth-scroll"
	
	
	// import Subscribe from "../../components/Subscribe"
	// import $ from "jquery"
	// import { DropdownButton, MenuItem, ButtonToolbar } from "react-bootstrap"
	// const Logo = "http://alpexonline.com/assets/images/LOGO.png"
	
	var NavBar = exports.NavBar = function (_React$Component) {
		_inherits(NavBar, _React$Component);
	
		function NavBar(args) {
			_classCallCheck(this, NavBar);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
			_this.handleScroll = function (event) {
				// // console.log("Scroolsadsadsd", event)
				var prevScrollpos = _this.state.prevScrollpos;
	
				var currentScrollPos = window.scrollY;
				// let itemTranslate = Math.min(0, currentScrollPos / 3)
				var visible = currentScrollPos === 0 && currentScrollPos - 1 < prevScrollpos;
				_this.setState({
					prevScrollpos: currentScrollPos,
					visible: visible
				});
			};
	
			_this.componentDidMount = function () {
				window.addEventListener("scroll", _this.handleScroll, true);
				_this.setState({
					// isNavChange: false,
					routeUrl: window.location.pathname
				});
				// setTimeout(() => {
				// 	this.setState({
				// 	})
				// }, 1000)
				// console.log(window.location)
			};
	
			_this.handleActiveNav = function (identifier) {
				var getActiveRoute = _this.props.getActiveRoute;
				// this.setState({
				// })
	
				_this.setState({
					// isNavChange: false,
					routeUrl: "/"
				});
				// setTimeout(() => {
				// 	this.setState({
				// 		isNavChange: true,
				// 	})
				// }, 0)
			};
	
			_this.state = {
				activeNav: "",
				prevScrollpos: window.pageYOffset,
				routeUrl: "/",
				isNavChange: true
			};
			return _this;
		}
	
		NavBar.prototype.componentWillUnmount = function componentWillUnmount() {
			window.removeEventListener("scroll", this.handleScroll, true);
		};
	
		NavBar.prototype.render = function render() {
			var _this2 = this;
	
			var _state = this.state,
			    activeNav = _state.activeNav,
			    routeUrl = _state.routeUrl,
			    isNavChange = _state.isNavChange;
			// console.log("this.props", this.props, routeUrl)
	
			var activeUrl = routeUrl === "/" || routeUrl === "/home";
			return _react2.default.createElement(
				"div",
				{ id: "navBar", className: "nav__bar" },
				_react2.default.createElement(
					"div",
					{ className: "logo" },
					_react2.default.createElement(
						"div",
						{ className: "" },
						_react2.default.createElement(
							"a",
							{ href: "/", className: "" },
							_react2.default.createElement("img", { src: "https://winpeforum.com/assets/elements/winpe_new_logo2.png", alt: "Winpe" })
						)
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "right__to__logo" },
					isNavChange ? _Routes2.default.map(function (route) {
						return _react2.default.createElement(
							"span",
							{ key: route.id, className: "dropdown blog" },
							route.isDifferentPage ? _react2.default.createElement(
								"div",
								null,
								_react2.default.createElement(
									"a",
									{ className: "" + (routeUrl === "/knowledgeresources" || routeUrl === "/connect" || routeUrl === "/insights" ? "" : ""), href: "/" + route.identifier },
									route.title
								)
							) : !activeUrl ? _react2.default.createElement(
								_gatsbyLink2.default,
								{ onClick: function onClick() {
										return _this2.handleActiveNav(route.title);
									}, to: "/home#" + route.identifier, className: " " + (route.identifier === activeNav.toLowerCase() ? "active" : "") },
								route.title
							) : _react2.default.createElement(
								"a",
								{ onClick: function onClick() {
										return _this2.handleActiveNav(route.title);
									}, href: "/home#" + route.identifier, className: "anchor__text " + (route.identifier === activeNav.toLowerCase() ? "active" : "") },
								route.title
							),
							_react2.default.createElement(
								"div",
								{ className: "dropdown-content" },
								route.dropdown && route.dropdown.map(function (item) {
									return item.isDifferentPage ? _react2.default.createElement(
										"div",
										{ key: item },
										_react2.default.createElement(
											"a",
											{ className: "", href: "/" + item.identifier, key: item.id },
											_react2.default.createElement(
												"span",
												null,
												item.title
											)
										)
									) : !activeUrl ? _react2.default.createElement(
										_gatsbyLink2.default,
										{ to: "/home#" + item.identifier, key: item.id, className: "" },
										_react2.default.createElement(
											"span",
											null,
											item.title
										)
									) : _react2.default.createElement(
										"a",
										{ href: "#" + item.identifier, key: item.id, className: "" },
										_react2.default.createElement(
											"span",
											null,
											item.title
										)
									);
								})
							)
						);
					}) : null
				),
				_react2.default.createElement(
					"div",
					{ className: "desTop_sm" },
					_react2.default.createElement(
						"div",
						{ className: "social_icons_top" },
						_react2.default.createElement(
							"div",
							{ className: "iconn" },
							_react2.default.createElement(
								"a",
								{ rel: "noopener noreferrer", href: "https://www.facebook.com/winpeforum/", target: "_blank", className: "" },
								_react2.default.createElement("i", { className: "fa fa-facebook" })
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "iconn" },
							_react2.default.createElement(
								"a",
								{ rel: "noopener noreferrer", href: "https://twitter.com/winpeforum", target: "_blank", className: "" },
								_react2.default.createElement("i", { className: "fa fa-twitter" })
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "iconn" },
							_react2.default.createElement(
								"a",
								{ rel: "noopener noreferrer", href: "https://www.linkedin.com/company/winpeforum", target: "_blank", className: "" },
								_react2.default.createElement("i", { className: "fa fa-linkedin" })
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "iconn" },
							_react2.default.createElement(
								"a",
								{ rel: "noopener noreferrer", href: "https://www.instagram.com/WinPEforum/", target: "_blank", className: "" },
								_react2.default.createElement("i", { className: "fa fa-instagram" })
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "iconn" },
							_react2.default.createElement(
								"a",
								{ rel: "noopener noreferrer", href: "https://www.youtube.com/watch?v=q-bE10X9KcA&t=2s", target: "_blank", className: "" },
								_react2.default.createElement("i", { className: "fa fa-youtube" })
							)
						)
					)
				)
			);
		};
	
		return NavBar;
	}(_react2.default.Component);
	
	NavBar.propTypes = {
		getActiveRoute: _propTypes2.default.func
	};
	
	exports.default = NavBar;

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _NavBar = __webpack_require__(400);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NavBar2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 769:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 788:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 790:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 798:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 806:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.PageLayout = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResponsive = __webpack_require__(23);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(806);
	
	__webpack_require__(798);
	
	__webpack_require__(788);
	
	var _reactSpinners = __webpack_require__(19);
	
	var _TopNavigationBar = __webpack_require__(401);
	
	var _TopNavigationBar2 = _interopRequireDefault(_TopNavigationBar);
	
	var _SidebarMobile = __webpack_require__(399);
	
	var _SidebarMobile2 = _interopRequireDefault(_SidebarMobile);
	
	__webpack_require__(790);
	
	var _Address = __webpack_require__(390);
	
	var _Address2 = _interopRequireDefault(_Address);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactBootstrap = __webpack_require__(21);
	
	var _regex = __webpack_require__(66);
	
	var _axios = __webpack_require__(56);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRedux = __webpack_require__(114);
	
	var _createStore = __webpack_require__(173);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var store = (0, _createStore2.default)();
	var WSLogo = "https://winpeforum.com/assets/elements/website-sketchers.png";
	var LOGO = "https://winpeforum.com/assets/elements/winpe_new_logo2.png";
	
	var PageLayout = exports.PageLayout = function (_React$Component) {
	  _inherits(PageLayout, _React$Component);
	
	  function PageLayout(agrs) {
	    _classCallCheck(this, PageLayout);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, agrs));
	
	    _this.toggleSidebar = function () {
	      _this.setState({
	        isShowSidebar: !_this.state.isShowSidebar
	      });
	    };
	
	    _this.toggleModal = function () {
	      _this.setState({
	        show: !_this.state.show
	      });
	    };
	
	    _this.handleEmail = function (e) {
	      e.preventDefault();
	      _this.setState({
	        subscriberEmail: e.target.value
	      });
	    };
	
	    _this.submitEmail = function () {
	      if ((0, _regex.validationForEmail)(_this.state.subscriberEmail)) {
	        // console.log("submit")
	        _this.setState({
	          emailError: false,
	          isSubmittingEmail: true
	        });
	        var emailParams = "email=" + _this.state.subscriberEmail;
	        _axios2.default.get("https://blackelephantdigital.in/blackele/sunny/api/winpe-api/public/newsletter_subscriber?" + emailParams).then(function (response) {
	          var data = response.data;
	
	          if (data === "Success") {
	            _this.setState({
	              isSubmitted: true,
	              isSubmittingEmail: false
	            });
	          } else {
	            _this.setState({
	              emailError: "This email is already subcribed",
	              isSubmittingEmail: false
	            });
	          }
	        });
	      } else {
	        _this.setState({
	          emailError: "Please enter a valid email address"
	        });
	      }
	    };
	
	    _this.state = {
	      isLoading: true,
	      isShowSidebar: false,
	      activeRouteName: "",
	      show: true
	    };
	    return _this;
	  }
	
	  PageLayout.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      _this2.setState({
	        isLoading: !_this2.state.isLoading
	      });
	    }, 100);
	  };
	
	  PageLayout.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        location = _props.location;
	    var _state = this.state,
	        isShowSidebar = _state.isShowSidebar,
	        isLoading = _state.isLoading,
	        emailError = _state.emailError,
	        isSubmitted = _state.isSubmitted,
	        show = _state.show,
	        isSubmittingEmail = _state.isSubmittingEmail;
	
	    var route = location.pathname.split("/")[1];
	    var appChildren =  true ? children({ location: location }) : children();
	    var activeRoute = location.hash;
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: store },
	      _react2.default.createElement(
	        "div",
	        { className: "page-layout__viewport" },
	        isLoading ? _react2.default.createElement(
	          "div",
	          { className: "loader__class" },
	          _react2.default.createElement(_reactSpinners.BarLoader, { color: "#22316B", loading: isLoading })
	        ) : null,
	        _react2.default.createElement(
	          "div",
	          { className: "page-layout__viewport__header" },
	          _react2.default.createElement(
	            "div",
	            { className: "menu__bar" },
	            _react2.default.createElement(
	              _reactResponsive2.default,
	              { query: "(min-width: 1230px)" },
	              _react2.default.createElement(
	                "div",
	                { className: "new_header_section" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "left_header_section" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "h_logo" },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: "/home/", className: "" },
	                      _react2.default.createElement("img", {
	                        src: "https://winpeforum.com/assets/elements/winpe_new_logo2.png",
	                        alt: "Winpe"
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "right_header_section" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "dropdown blog" },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: "/home#about" },
	                      "about"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "dropdown-content" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-12" },
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { className: "", to: "/home#vision" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "t_n" },
	                              "Vision"
	                            )
	                          ),
	                          " "
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-12" },
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { className: "", to: "/home#team" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "t_n" },
	                              "People"
	                            )
	                          ),
	                          " "
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-12" },
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { className: "", to: "/press/" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "t_n" },
	                              "press"
	                            )
	                          ),
	                          " "
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-12" },
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { className: "", to: "/winpecharter/" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "t_n" },
	                              "Charter"
	                            )
	                          ),
	                          " "
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "dropdown blog" },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: "/home#initiatives" },
	                      "initiatives"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "dropdown-content" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-12" },
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: "/events/" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "t_n" },
	                              "events"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-12" },
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: "/testimonials/" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "t_n" },
	                              "testimonials"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "dropdown1 blog" },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: "/insights/" },
	                      "insights"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "dropdown-content" },
	                      _react2.default.createElement("div", { className: "row" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "dropdown2 blog" },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: "/home#partners" },
	                      "partners"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "dropdown blog" },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: "/knowledgeresources/" },
	                      "knowledge center"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "dropdown blog" },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: "/connect/" },
	                      "connect"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "new_desTop_sm" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "social_icons_top" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "iconn" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          rel: "noopener noreferrer",
	                          href: "https://www.facebook.com/winpeforum/",
	                          target: "_blank",
	                          className: ""
	                        },
	                        _react2.default.createElement("i", { className: "fa fa-facebook" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "iconn" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          rel: "noopener noreferrer",
	                          href: "https://twitter.com/winpeforum",
	                          target: "_blank",
	                          className: ""
	                        },
	                        _react2.default.createElement("i", { className: "fa fa-twitter" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "iconn" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          rel: "noopener noreferrer",
	                          href: "https://www.linkedin.com/company/winpeforum",
	                          target: "_blank",
	                          className: ""
	                        },
	                        _react2.default.createElement("i", { className: "fa fa-linkedin" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "iconn" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          rel: "noopener noreferrer",
	                          href: "https://www.instagram.com/WinPEforum/",
	                          target: "_blank",
	                          className: ""
	                        },
	                        _react2.default.createElement("i", { className: "fa fa-instagram" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "iconn" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          rel: "noopener noreferrer",
	                          href: "https://www.youtube.com/@winpeforum791",
	                          target: "_blank",
	                          className: ""
	                        },
	                        _react2.default.createElement("i", { className: "fa fa-youtube" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "iconn" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          rel: "noopener noreferrer",
	                          href: "https://winpeinsights.medium.com/",
	                          target: "_blank",
	                          className: ""
	                        },
	                        _react2.default.createElement("i", { className: "fa fa-medium", "aria-hidden": "true" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "iconn" },
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          rel: "noopener noreferrer",
	                          href: "https://www.winpeforum.com/whatsappgroups/",
	                          target: "_blank",
	                          className: ""
	                        },
	                        _react2.default.createElement("i", { className: "fa fa-whatsapp" })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactResponsive2.default,
	              { query: "(max-width: 1230px)" },
	              _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                  "span",
	                  { className: "logo" },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: "/" },
	                    _react2.default.createElement("img", {
	                      src: LOGO,
	                      alt: "Winpe",
	                      className: "mobile__logo"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "hmb pull-right", onClick: this.toggleSidebar },
	                  _react2.default.createElement("i", { className: "fa fa-bars" })
	                ),
	                _react2.default.createElement(_SidebarMobile2.default, {
	                  show: isShowSidebar,
	                  onHide: this.toggleSidebar,
	                  activePathname: activeRoute
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "background__wrapper" },
	          _react2.default.createElement("div", { className: "background__texture" })
	        ),
	        appChildren,
	        _react2.default.createElement(
	          "div",
	          { className: "page-layout__viewport__footer_content" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactResponsive2.default,
	              { query: "(min-width:1001px)" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4 col-sm-4" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "left__content" },
	                    "\xA9 Winpe 2021. All Rights Reserved. ",
	                    _react2.default.createElement(
	                      "a",
	                      { style: { color: '#fff', textDecoration: 'underline' }, href: "https://winpeforum.com/terms-of-use/" },
	                      "Winpe App: Terms of Use"
	                    ),
	                    "."
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4 col-sm-4" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "middle__content" },
	                    _react2.default.createElement(_Address2.default, null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4 col-sm-4" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "right__content" },
	                    "Powered By",
	                    " ",
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "https://websitesketchers.com",
	                        rel: "noopener noreferrer",
	                        target: "_blank",
	                        className: "",
	                        style: { color: "#ffffff" }
	                      },
	                      "Website Sketchers"
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _reactResponsive2.default,
	              { query: "(max-width:1000px)" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "m_add" },
	                  _react2.default.createElement(_Address2.default, null)
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-12 col-xs-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "left__content" },
	                    "\xA9 Winpe 2021. All Rights Reserved. ",
	                    _react2.default.createElement(
	                      "a",
	                      { style: { color: '#fff', textDecoration: 'underline' }, href: "https://winpeforum.com/terms-of-use/" },
	                      "Terms of Use"
	                    ),
	                    "."
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-12 col-xs-12" },
	                  _react2.default.createElement("div", { className: "middle__content" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-12 col-xs-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "right__content" },
	                    "Powered By",
	                    " ",
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        href: "https://websitesketchers.com",
	                        rel: "noopener noreferrer",
	                        target: "_blank",
	                        className: "",
	                        style: { color: "#ffffff" }
	                      },
	                      "Website Sketchers"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return PageLayout;
	}(_react2.default.Component);
	
	PageLayout.propTypes = {
	  children: _propTypes2.default.func,
	  location: _propTypes2.default.object
	};
	
	exports.default = PageLayout;

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(236);
	
	var reducer = function reducer(state, action) {
		// console.info("--------------------")
		// console.info("\x1b[36m", "prev state -> ", state)
		// console.info("\x1b[36m", "action", action)
		if (action.type === "INCREMENT") {
			state = _extends({}, state, {
				count: state.count + action.index
			});
			// return state
		}
		if (action.type === "FETCHED_PRODUCT_LIST") {
			var list = action.list;
	
			var listItemById = {};
			var infoListItemById = {};
			var wholeMasalas = [];
			var blendedMasalas = [];
			var specialities = [];
			var pujaMaterials = [];
			list.map(function (item) {
				var _extends2;
	
				infoListItemById = _extends({}, infoListItemById, (_extends2 = {}, _extends2[item.info_id] = item, _extends2));
				if (listItemById[item.id] === undefined || listItemById[item.id] === null) {
					listItemById[item.id] = [];
				}
				if (item.ingredients === "1" && item.type_id === "Spices") {
					wholeMasalas.push(item);
				} else if (item.type_id === "Spices") {
					blendedMasalas.push(item);
				}
				if (item.type_id === "Misc") {
					specialities.push(item);
				} else if (item.type_id === "Dhoop") {
					pujaMaterials.push(item);
				}
				listItemById[item.id].push(item);
			});
			state = _extends({}, state, {
				products: _extends({}, state.products, {
					list: list,
					listItemById: listItemById,
					infoListItemById: infoListItemById,
					wholeMasalas: wholeMasalas,
					blendedMasalas: blendedMasalas,
					specialities: specialities,
					pujaMaterials: pujaMaterials,
					meta: {
						isFetching: false
					}
				})
			});
			// return state
		}
		if (action.type === "ADD_TO_CART") {
			var _list = action.list;
	
			state = _extends({}, state, {
				products: _extends({}, state.products, {
					cart: _list,
					cartChange: !state.products.isCartChange
				})
			});
		}
		// console.info("\x1b[36m", "next state -> ", state)
		// console.info("--------------------")
		// state = { ...stateObj }
		return state;
	};
	
	var initialState = { count: 0, products: { list: [], meta: { isFetching: true }, cart: {}, cartChange: false } };
	
	var createStore = function createStore() {
		return (0, _redux.createStore)(reducer, initialState);
	};
	exports.default = createStore;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-26520c046d4b765dc120.js